import React from 'react';
import {Autocomplete, TextField} from '@mui/material';
import {ContentColor, ContentColors} from '../../styles/colorCode';

interface ColorPickerProps {
  setColor: (value: ContentColor) => void,
  value: any
}

const ColorPicker = ({setColor, value}: ColorPickerProps) => {
  const availableColor = ContentColors.map(c => ({label: c, id: c}));
  const autocompleteOnChange = (event: React.SyntheticEvent<Element, Event>, value: any) => setColor(value.id);

  return (
    <Autocomplete
      sx={{paddingBottom: 2}}
      id="user-input-color"
      disableClearable
      options={availableColor}
      value={value}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={(event: React.SyntheticEvent<Element, Event>, value: any) => autocompleteOnChange(event, value)}
      renderInput={(params) => <TextField {...params} label="Color" required/>}
    />
  );

};

export default ColorPicker;
